// "use client"
// import { useEffect, useState } from "react";
// import { ArrowUp } from "lucide-react";

// export const ScrollToTop = () => {
//   const [show, setShow] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setShow(window.scrollY > 300);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   return (
//     <button
//       onClick={scrollToTop}
//       className={`fixed bottom-4 right-4 z-50 p-2 rounded-full bg-primary text-white shadow-lg transition-opacity duration-300 ${
//         show ? "opacity-100" : "opacity-0 pointer-events-none"
//       }`}
//     >
//       <ArrowUp className="w-5 h-5" />
//     </button>
//   );
// };
"use client";
import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { IoIosArrowUp } from "react-icons/io";
const ScrollToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-4 right-4 z-50 p-2 rounded-full bg-primary text-white shadow-lg transition-opacity duration-300 ${
        show ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
  <IoIosArrowUp size="24px" color="white" />

    </button>
  );
};

export default ScrollToTop;
